import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { translate } from './Translate';
import Icon from './Icon';

const SearchWrapper = styled<any, any>('div')`
    ${propStyles};
`;

SearchWrapper.defaultProps = {
    flex: "1 0 auto",
    display: "flex",
    order: ["1", "0"],
    alignItems: "center",
    bgColor: "white",
    borderWidth: "1px",
    borderColor: "gray300",
    borderStyle: "solid",
    borderRadius: "sm",
    paddingX: "sm",
    paddingY: "xs",
    minHeight: "40px"
};

const SearchInput = styled<any, any>('input')`
    ${propStyles};
    border: none;
    outline: none;
    &::-ms-clear {
        display: none;
    }
`;

SearchInput.defaultProps = {
    flex: "1 0 auto",
    fontSize: "inherit",
    fontFamily: "inherit",
    fontWeight: "inherit",
    padding: "sm"
};

interface Search {
    theme?: any;
    translations?: object;
    total: number;
    identifierSearch: string;
    onChange: Function;
    clearSearch: Function;
}

export const Search: React.SFC<Search> = ({ theme, translations, total, onChange, clearSearch, identifierSearch }) => (
    <SearchWrapper
        {...theme.SearchWrapper}
    >
        <Icon fileName="SearchIcon" />
        <SearchInput
            type="text"
            value={identifierSearch}
            onChange={e => onChange(e.target.value)}
            placeholder={translate(translations, 'Search {total} share classes', { total })}
            autoCapitalize="off"
            autoComplete="off"
            spellCheck="false"
            autoCorrect="off"
            {...theme.SearchInput}
        />
        {
            identifierSearch && (
                <Icon
                    fileName="CloseIcon"
                    title={translate(translations, "Clear Search")}
                    onClick={clearSearch}
                    cursor="pointer"
                />
            )
        }
    </SearchWrapper>
);

export default inject('translations')(withTheme(observer(Search))) as any;



// WEBPACK FOOTER //
// ./src/Components/Search.tsx